class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));

    this.loyalty()
  }

  loyalty() {
    $(document).on("swell:setup", function() {
      let customerDetails = swellAPI.getCustomerDetails();
      let pointsMultiplier = 1;

      if (customerDetails) {
        if (customerDetails.vipTier && customerDetails.vipTier.pointsMultiplier) pointsMultiplier = parseFloat(customerDetails.vipTier.pointsMultiplier);
        if (pointsMultiplier === 1.5) $('.cart_f_shipping').addClass('hidden')
        window.pointsMultiplier = pointsMultiplier;
        CartItems.renderLoyalty();
      }
    })
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        if (parsedState.item_count === 0) $('.pdp-loyalty-wrap').html('');

        var item_in_bag = " Items";
        if(parsedState.item_count === 1 ) item_in_bag = " Item";
        document.getElementById('bb-number-items').innerText = parsedState.item_count + item_in_bag;
        $('#bb-number-items2').text("("+parsedState.item_count + item_in_bag+")");

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }

        let free_shipping = parseInt($('.cart_f_shipping._desktop').attr('data-price-free'));
        let ammount_p = parsedState.total_price * 100 / free_shipping;
        ammount_p = ammount_p.toFixed(0);

        if ($('.shipping-free-in-cart').length) ammount_p = 100;
        if ($('.user--free-shipping').length) ammount_p = 100;

        if (ammount_p >= 100) {
          ammount_p = 100;
          $('.cart_f_shipping p').text($('.cart_f_shipping._desktop').attr('data-text-free'));
        } else {
          let money_ = window.currency_symbol + (free_shipping - parsedState.total_price) / 100;
          let money_text = $('.cart_f_shipping._desktop').attr('data-text-missing').replace('{{ count }}', money_)
          $('.cart_f_shipping p').html(money_text);
        }
        $('.progress-container .progress-bar').css('width', `${ammount_p}%`);


        if (!$('.horizon-in-cart').length) { $('.cart__horizon_program').removeClass('hidden'); $('.cart-gift-donation ').removeClass('hidden'); };
        if (!$('.shipping-free-in-cart').length) { $('.cart__free_shipping').removeClass('hidden'); $('.cart-gift-donation ').removeClass('hidden'); };

        $('.totals._mobile p.totals__subtotal-value').html($('.totals._desktop p.totals__subtotal-value').html());

        CartItems.renderLoyalty();

        this.disableLoading();
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
      const cartLineError = document.getElementById(`cart-item-error-${line}`);
      if(cartLineError) {
        cartLineError
            .innerHTML = '<span class="item-cart-message-error">' + window.cartStrings.quantityError.replace(
            '[quantity]',
            quantityElement.value
        )+ '</span>';
      }

      lineItemError
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          quantityElement.value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
  }

  static renderLoyalty() {
     $('.cart-loyalty-render').each(function () {
      let item_ = $(this);
      let point = parseInt(item_.attr('data-price'));
      item_.html(`<p class="pdp-loyalty-wrap-customer">+<span>${Math.floor(point * window.pointsMultiplier)}</span> POINTS</p>`)
    });
    let text2 = $('.cart-loyalty-render2').attr('data-text');
    let point2 = parseInt($('.cart-loyalty-render2').attr('data-price')) * window.pointsMultiplier;
    $('.cart-loyalty-render2').html(`<span>${text2}</span><span class="points">${point2} points</span>`);
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, 300))
    }
  });
};

$( document ).ready(function() {
  $('.cart__footer').on('click', '.cart_fprice-title', function () {
    $(this).parent().toggleClass('open')
  });
})